if (!customElements.get('site-header')) {
  customElements.define('site-header', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.menu = this.querySelector('[data-header-nav]');
      this.menuToggle = this.querySelector('[data-menu-toggle]');
      this.search = this.querySelector('[data-header-search]');
      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.mobile = window.matchMedia('(max-width: 860px)');
      document.addEventListener('cart:opening', () => { this.closeMenu(); this.closeSearch(); }, options);
      this.closeMenu();
      this.closeSearch();
      this.setAttribute('data-enhanced', '');
      this.menuToggle.addEventListener('click', () => {
        const open = this.menuToggle.getAttribute('aria-expanded') !== 'true';
        this.closeSearch();
        this.menuToggle.setAttribute('aria-expanded', String(open));
        this.menu.hidden = !open;
        if (open) this.menu.querySelector('a, summary')?.focus();
      }, options);
      this.searchToggle?.addEventListener('click', () => {
        const open = this.searchToggle.getAttribute('aria-expanded') !== 'true';
        this.closeMenu();
        this.setSearchOpen(open);
        if (open) this.search.querySelector('input').focus();
      }, options);
      this.querySelector('[data-search-close]')?.addEventListener('click', () => this.closeSearch(true, true), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const submenu = event.target.closest('details[open]');
        if (submenu) {
          submenu.open = false;
          submenu.querySelector('summary').focus();
        } else if (this.search && this.searchToggle.getAttribute('aria-expanded') === 'true') this.closeSearch(true, true);
        else if (this.mobile.matches && !this.menu.hidden) this.closeMenu(true);
        else return;
        event.preventDefault();
      }, options);
      this.mobile.addEventListener('change', () => {
        const focusInMenu = this.menu.contains(document.activeElement);
        this.closeMenu(this.mobile.matches && focusInMenu);
      }, options);
      this.addEventListener('focusout', event => {
        // Safari can blur a focused input/link to BODY before an internal tap
        // dispatches click. A null target must not hide that pending control.
        if (event.relatedTarget && !this.contains(event.relatedTarget)) {
          this.closeMenu();
          this.closeSearch();
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!event.composedPath().includes(this)) {
          this.closeMenu();
          this.closeSearch();
        }
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) {
          this.closeMenu();
          this.closeSearch();
        }
      }, options);
    }
    closeMenu(restoreFocus = false) {
      this.menu.hidden = this.mobile.matches;
      this.menuToggle.setAttribute('aria-expanded', 'false');
      this.menu.querySelectorAll('details[open]').forEach(details => { details.open = false; });
      if (restoreFocus) this.menuToggle.focus();
    }
    setSearchOpen(open, animate = true) {
      if (!this.search) return;
      const startHeight = this.search.hidden ? 0 : this.search.getBoundingClientRect().height;
      const startOpacity = this.search.hidden ? 0 : Number(getComputedStyle(this.search).opacity);
      const startMargin = this.search.hidden ? 0 : parseFloat(getComputedStyle(this.search).marginTop);
      this.searchAnimation?.cancel();
      this.searchAnimation = null;
      if (open) this.search.hidden = false;
      this.searchToggle.setAttribute('aria-expanded', String(open));
      this.search.inert = !open;

      if (!animate || !this.search.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.search.hidden = !open;
        this.search.style.removeProperty('overflow');
        return;
      }

      const endHeight = open ? this.search.scrollHeight : 0;
      const endMargin = open ? parseFloat(getComputedStyle(this.search).marginTop) : 0;
      this.search.style.overflow = 'hidden';
      const animation = this.search.animate([
        { height: `${startHeight}px`, marginTop: `${startMargin}px`, opacity: startOpacity },
        { height: `${endHeight}px`, marginTop: `${endMargin}px`, opacity: open ? 1 : 0 }
      ], { duration: 240, easing: 'ease-in-out' });
      this.searchAnimation = animation;
      animation.onfinish = () => {
        this.search.hidden = !open;
        this.search.style.removeProperty('overflow');
        this.searchAnimation = null;
      };
    }
    closeSearch(restoreFocus = false, animate = false) {
      if (!this.search || (this.search.hidden && !this.searchAnimation)) return;
      this.setSearchOpen(false, animate);
      if (restoreFocus) this.searchToggle.focus();
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.searchAnimation) {
        this.searchAnimation.onfinish = null;
        this.searchAnimation.cancel();
        this.searchAnimation = null;
        this.search.hidden = this.searchToggle.getAttribute('aria-expanded') !== 'true';
        this.search.style.removeProperty('overflow');
      }
    }
  });
}
